import { useQuery } from '@tanstack/react-query';
import CatalogService from '@utility/services/catalog';
import { buildConflictsCountParams } from '../lib/list-params';
import { catalogKeys } from '../lib/query-keys';

export function useCatalogConflictsCount(regionId: unknown) {
  return useQuery({
    queryKey: catalogKeys.conflictsCount(regionId),
    queryFn: () =>
      CatalogService.getCatalogConflictsCount(
        buildConflictsCountParams(regionId),
      ),
    enabled: !!regionId,
  });
}
